import { buildDiagnosticViewModel } from '../modules/listing/diagnostic-center/diagnostic-viewmodel.js';
import { selectListingDraftState } from './listing-selectors.js';

export function selectDiagnosticViewModelInput(state = {}) {
  const listing = selectListingDraftState(state);
  return {
    complianceResult: listing.complianceResult,
    scoringReport: listing.scoringReport,
    revisionSuggestions: listing.revisionSuggestions,
    revisionOverview: listing.revisionOverview,
    revisionSuggestionsMeta: state.revisionSuggestionsMeta,
    revisionSuggestionsError: listing.revisionSuggestionsError,
    listingDraftTitle: listing.title,
    listingDraftBullets: { bulletsEn: listing.bullets },
    listingDraftDescription: listing.description,
    listingDraftSearchTerms: { searchTermsEn: listing.searchTerms },
    listingDraftQa: listing.qa,
    marketplace: state.marketplace,
    diagnosticMarketplace: state.diagnosticMarketplace,
    productInfo: state.productInfo,
    businessContext: state.businessContext,
    keywordUsePolicies: state.keywordUsePolicies,
    competitorRoles: state.competitorRoles,
    listingGenerationMeta: state.listingGenerationMeta,
    diagnosisInFlight: state.diagnosisInFlight === true,
  };
}

export function selectDiagnosticViewModel(state = {}) {
  return buildDiagnosticViewModel(selectDiagnosticViewModelInput(state));
}
